if (!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
    constructor() {
      super();

      this.handleVariantChangeRef = this.handleVariantChange.bind(this);
    }

    handleVariantChange(event) {
      if(event.detail.productId != this.getAttribute('data-product-id')) return;
      if(!event.detail.option) return;

      let priceHtml = event.detail.option.getAttribute('data-price');
      if(!priceHtml) return;

      this.innerHTML = priceHtml;
    }

    disconnectedCallback() {
      document.removeEventListener('alexa:variant-change', this.handleVariantChangeRef);
    }

    connectedCallback() {
      document.addEventListener('alexa:variant-change', this.handleVariantChangeRef);
    }
  }

  customElements.define('product-price', ProductPrice);
}
